export default __webpack_public_path__ + "static/media/checked-speech-bubble.2568552d.svg";